module.exports = __webpack_public_path__ + "static/medicalreel_jm-bb5c9156d46fe0b2ec541b532cf9df66.jpg";